/**
 * Backend
 */

// This and all after versions is not supported by backward compatibility
export const PROJECT_BACK_COMPATIBILITY_BEFORE = '1.3.0'

/**
 * Frontend
 */
export const FRONTEND_COMPATIBILITY_BEFORE_2_5_332 = '2.5.332'
export const FRONTEND_COMPATIBILITY_BEFORE_2_5_370 = '2.5.370'
export const FRONTEND_COMPATIBILITY_BEFORE_2_5_390 = '2.5.390'
export const FRONTEND_COMPATIBILITY_BEFORE_2_5_411 = '2.5.411'
